import WidgetBase from '../widget.base';

export default class AttractionGallery extends WidgetBase {
    static selector = '[data-ww-attraction-gallery]';
    activeClass = 'active';
    hiddenClass = 'hidden';
    menuSelector = '[data-menu-item]';
    cardSelector = '[data-categories]';
    menuItems = [];
    cards = [];

    constructor(el){
        super(el);
        this.menuItems = this.el.querySelectorAll(this.menuSelector);
        this.cards = this.el.querySelectorAll(this.cardSelector);

        for(let i = 0; i < this.menuItems.length; i++){
            this.menuItems[i].addEventListener('click', this.menuItemClicked);
        }

        //this.initializeCount()
        this.initialize();
    }

    initialize() {

        //Check for a ?filter query param, and if found, click the selected filter
        const params = this.parseUrlParams();

        if(params.hasOwnProperty('filter') && params.filter) {
            this.el.querySelectorAll('[data-filter]')
                .forEach(el => {
                    if (el.dataset.filter.toUpperCase() === params.filter.toUpperCase()) {
                        el.click();
                    }
                });
        }
    }

    initializeCount(){
        for(let i = 0; i < this.menuItems.length; i++){
            let count = 0;
            let category = this.menuItems[i].dataset.filter.toUpperCase();

            if(category === "ALL"){
                count = this.cards.length;;
            } else {
            for(let j = 0; j < this.cards.length; j++){
                    let cardCategories = JSON.parse(this.cards[j].dataset.categories).map((val) => val.toUpperCase());
                    if(cardCategories.indexOf(category) > -1){
                        count++;
                    }
                }
            }
            this.menuItems[i].insertAdjacentHTML('beforeend', ' ('+count+')');
        }
    }

    menuItemClicked = (e) =>{
        e.preventDefault();
        let filterCategory = e.target.dataset.filter.toUpperCase();
        this.removeAllActiveMenuItems();
        this.removeAllActiveCards();

        e.target.classList.add(this.activeClass);
        this.filterCards(filterCategory);
    }

    filterCards(categories){
        for(let i = 0; i < this.cards.length; i++){
            if(categories === "ALL"){
                this.cards[i].classList.remove(this.hiddenClass);
            } else {
                let cardCategories = JSON.parse(this.cards[i].dataset.categories).map((val) => val.toUpperCase());
                if(cardCategories.indexOf(categories) > -1){
                    this.cards[i].classList.remove(this.hiddenClass);
                }
            }
        }
    }

    removeAllActiveMenuItems(){
        for(let i = 0; i < this.menuItems.length; i++){
            this.menuItems[i].classList.remove(this.activeClass);
        }
    }

    removeAllActiveCards(){
        for(let i = 0; i < this.cards.length; i++){
            this.cards[i].classList.add(this.hiddenClass);
        }
    }
    
    getUrlVars() {
        let vars = {};
        const parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m,key,value) => {
            vars[key] = decodeURI(value);
        });
        return vars;
    }

    parseUrlParams() {
        let params = this.getUrlVars();

        return {
            filter: params['filter']
        };
    }
}